import { Global, css, ThemeProvider as Provider } from "@emotion/react";
import get from "lodash.get";
import "focus-visible";
import { UIDReset } from "react-uid";
import React from "react";
import defaultTheme, { CatchTheme } from "./theme";

interface ThemeProviderProps {
  theme?: CatchTheme;
  children?: React.ReactNode;
  enableGlobalFontConfig?: boolean;
  enableGlobalBoxSizingConfig?: boolean;
  enableGlobalBackgroundConfig?: boolean;
  appName?: string;
  disableStyledSystemCache?: boolean;
}

const globalFontStyles = (theme) => `
  body {
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    color: ${get(theme, "colors.typography.text")};
    font-family: ${get(theme, "fonts.catch")};
    font-size: ${get(theme, "fontSizes.base")};
    line-height: ${get(theme, "lineHeights.normal")};
  }
`;

const globalBoxSizing = `
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
`;

const globalBackgroundConfig = (theme) => `
  body {
    background-color: ${get(theme, "colors.ui.backgroundColorMobile")};
    @media screen and (min-width: ${get(theme, "breakpoints.md")}) {
      background-color: ${get(theme, "colors.ui.backgroundColor")};
    }
  }
`;

const ThemeProvider: React.FC<ThemeProviderProps> = ({
  theme = defaultTheme,
  children,
  enableGlobalFontConfig = true,
  enableGlobalBoxSizingConfig = true,
  enableGlobalBackgroundConfig = false,
  appName = "catch-app",
  disableStyledSystemCache = false,
  ...otherProps
}) => (
  <UIDReset>
    <Provider
      theme={{ ...theme, appName, disableStyledSystemCache }}
      {...otherProps}
    >
      <Global
        styles={css`
          ${enableGlobalFontConfig && globalFontStyles(theme)}
          ${enableGlobalBoxSizingConfig && globalBoxSizing}
          ${enableGlobalBackgroundConfig && globalBackgroundConfig(theme)}
        `}
      />

      {children}
    </Provider>
  </UIDReset>
);

export default ThemeProvider;
